export const environment = {
  isProduction: false,
  environment: 'staging',
};
